import { Dropdown, Toast } from 'bootstrap'

const shareDropdownButtons =
  document.querySelectorAll<HTMLElement>('[data-share]')

for (const btn of shareDropdownButtons) {
  if (navigator.share) {
    btn.addEventListener('click', () => {
      navigator.share({
        title: btn.dataset.shareTitle,
        text: btn.dataset.shareText,
        url: window.location.href
      })
    })
  } else {
    btn.dataset.bsToggle = 'dropdown'
    Dropdown.getOrCreateInstance(btn)
    const dropdownEl = btn.closest<HTMLElement>(
      '.dropdown-center, .dropdown, .dropdown-end'
    )
    const copyLinkEl =
      dropdownEl?.querySelector<HTMLElement>('[data-copy-link]')
    if (!copyLinkEl) {
      continue
    }
    const toastEl = document.querySelector<HTMLElement>(
      copyLinkEl.dataset.copyLinkToast ?? ''
    )

    copyLinkEl?.addEventListener('click', async () => {
      if (!toastEl) {
        return
      }
      await navigator.clipboard?.writeText(window.location.href)
      const toastInstance = Toast.getOrCreateInstance(toastEl)
      toastInstance.show()
    })
  }
}
